<div class="deal-card card h-100" [class.clickable]="showCompanyInfo" (click)="showCompanyInfo ? goToStore() : null">
  <div class="deal-image-container">
    @if (deal.image_url) {
      <img [src]="deal.image_url" alt="Deal Image" class="deal-image" />
    } @else {
      <div class="deal-image-placeholder">
        <i class="fa fa-tag fs-2x"></i>
      </div>
    }
    @if (deal.discount_percentage) {
      <div class="discount-badge">
        {{ deal.discount_percentage }}% OFF
      </div>
    }
    @if (isDealActive()) {
      <div class="status-badge active">{{ 'common.active' | translate }}</div>
    }
  </div>
  <div class="card-body">
    @if (showCompanyInfo && deal.company) {
      <div class="company-info mb-2">
        <div class="d-flex align-items-center">
          @if (deal.company.company_logo_url) {
            <img [src]="deal.company.company_logo_url" alt="Store Logo" class="company-logo me-2" />
          } @else {
            <div class="company-logo-placeholder me-2">
              <i class="fa fa-store"></i>
            </div>
          }
          <span class="company-name">{{ deal.company.company_name }}</span>
        </div>
      </div>
    }
    <h5 class="deal-title mb-2">{{ deal.title }}</h5>
    @if (deal.description) {
      <p class="deal-description text-muted mb-2">{{ deal.description }}</p>
    }
    <div class="deal-dates text-muted small mb-3">
      <i class="fa fa-calendar me-1"></i>
      {{ deal.start_date | date:'mediumDate' }} - {{ deal.end_date | date:'mediumDate' }}
    </div>
    <div class="discount-code-section">
      <span class="code-label">{{ 'storesServices.discountCode' | translate }}:</span>
      @if (!isCodeHidden) {
        <code class="discount-code">{{ deal.discount_code }}</code>
      } @else {
        <div class="blurred-code-container">
          <code class="discount-code blurred">XXXXXXXX</code>
          <div class="login-prompt">
            <a (click)="goToRegister(); $event.stopPropagation()">{{ 'storesServices.createAccountToSeeCode' | translate }}</a>
          </div>
        </div>
      }
    </div>
  </div>
</div>
